// source: template-project@7007a338a apps/backoffice/src/components/ui/shadcn/checkbox.tsx
import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check, Minus } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // size-4 + aspect-square: table-fixed select columns used to squeeze
      // h/w independently (40px cell − px-3 left a ~16px slot), so the box
      // read as an oval. Keep both axes locked together.
      // rounded-xs (4px): the DS radius ramp maps rounded-sm to 8px, which on a
      // 16px box is a full circle and reads as a radio button.
      "grid aspect-square size-4 shrink-0 place-content-center peer rounded-xs border border-ds-border-default ring-offset-background transition-colors duration-200 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("group/indicator grid place-content-center text-current")}
    >
      {/* The mark sits well inside the 16px box; a heavier stroke keeps it legible at 10px. */}
      {/* ds-allow: icon-size */}
      <Check strokeWidth={3} className="size-2.5 group-data-[state=indeterminate]/indicator:hidden" />
      {/* ds-allow: icon-size */}
      <Minus strokeWidth={3} className="hidden size-2.5 group-data-[state=indeterminate]/indicator:block" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
